import * as api from '@/api/hero'
import Hero from '@/store/models/hero'
import formData from '@billow/js-helpers/src/utilities/form-data'

export let state = {
  hero: new Hero,
  heroList: {}
}

export let mutations = {
  setHeroList: (state, payload) => state.heroList = payload,
  addHero(state, hero) {state.heroList.push(hero)},

  reset: state => state.hero = new Hero,
  setHero: (state, payload) => state.hero = (new Hero).hydrate(payload),
  setFile: (state, payload) => state.hero.file = payload
}

export let actions = {

  all: ({ commit }) => new Promise((resolve, reject) => {
    api.all(response => {
      commit('setHeroList', response.data)
      resolve()
    }, reject)
  }),

  create: ({ state, commit }) => new Promise((resolve, reject) => {
    api.create(formData(state.hero), () => {
      commit('addHero')
      commit('reset')
      resolve()
    }, reject)
  }),

  save: ({ state, commit }) => new Promise((resolve, reject) => {
    api.save(state.hero.id, formData(state.hero), () => {
      commit('reset')
      resolve()
    }, reject)
  }),

  remove: ({ }, hero) => new Promise((resolve, reject) => {
    api.remove(hero.id, resolve, reject)
  })

}